import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from '../TableActionCell.st.css.js';
const HoverSlot = ({ display, children, ...props }) => (React.createElement("span", { className: st(classes.hoverSlot, classes[display]), "data-display": display, ...props }, children));
HoverSlot.propTypes = {
    display: PropTypes.oneOf(['always', 'onHover', 'notOnHover']),
    children: PropTypes.node,
};
export default HoverSlot;
//# sourceMappingURL=HoverSlot.js.map